import { useEffect, useState } from 'react';
import PublicLandingPage from './StaticComponents/publicLanding/PublicLandingPage';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import StudentDashboard from './DynamicPages/StudentDashboard';
import AdminPanel from './Admin/AdminPanel';
import AdminRoute from './Admin/AdminRoute';
import AdminLogin from './Admin/AdminLogin';
import OnboardingPage from './DynamicPages/Onboarding/Components/OnboardingPage';
import PartnerDashboard from './DynamicPages/PartnerDashboard';
import CourseCheckout from './DynamicPages/CourseCheckout';
import InterviewCheckout from './DynamicPages/InterviewCheckout';
import ActivationPage from './DynamicPages/ActivationPage';
import AuthModal, { isStudentAuthFlowActive } from './StaticComponents/AuthModal';
import LegalDocumentPage from './StaticComponents/LegalDocumentPage';
import MockInterviewsPage from './StaticComponents/mockInterviews/MockInterviewsPage';
import InternshipsPage from './StaticComponents/internships/InternshipsPage';
import InternshipDetailPage from './StaticComponents/internships/InternshipDetailPage';
import WorkshopsPage from './StaticComponents/workshops/WorkshopsPage';
import WorkshopDetailPage from './StaticComponents/workshops/WorkshopDetailPage';
import EnrollmentSuccessPage from './DynamicPages/EnrollmentSuccessPage';
import { auth } from './Lib/Firebase';
import { privacyDocument, termsDocument } from './data/legalDocuments';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/" element={<HomeRoute />} />
        <Route path="/dashboard" element={<StudentDashboard />} />
        <Route path="/checkout/course/:courseRunId" element={<CourseCheckout />} />
        <Route path="/checkout/interview/:tier/:slotId" element={<InterviewCheckout />} />
        <Route path="/enrollment/success" element={<EnrollmentSuccessPage />} />
        <Route path="/activate" element={<ActivationPage />} />
        <Route path="/partners" element={<PartnerDashboard />} />
        <Route path="/terms" element={<LegalDocumentPage document={termsDocument} kind="terms" />} />
        <Route path="/privacy" element={<LegalDocumentPage document={privacyDocument} kind="privacy" />} />
        <Route path="/mock-interviews" element={<MockInterviewsPage />} />
        <Route path="/internships" element={<InternshipsPage />} />
        <Route path="/internships/:internshipSlug" element={<InternshipDetailPage />} />
        <Route path="/workshops" element={<WorkshopsPage />} />
        <Route path="/workshops/:workshopSlug" element={<WorkshopDetailPage />} />
        <Route path="/partner" element={<Navigate to="/partners" replace />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminPanel />
            </AdminRoute>
          }
        />
        {/* Optional direct login page */}
        <Route path="/admin-login" element={<AdminLogin />} />
        {/* Default: send unknown routes to / for now */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <AuthModal />
    </BrowserRouter>
  );
};

function HomeRoute() {
  const [sessionResolved, setSessionResolved] = useState(false);
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => onAuthStateChanged(auth, (user) => {
    setSignedIn(Boolean(user));
    setSessionResolved(true);
  }), []);

  if (!sessionResolved) return <main className="min-h-screen bg-slate-50" aria-label="Restoring your session" />;
  return signedIn && !isStudentAuthFlowActive() ? <Navigate to="/dashboard" replace /> : <PublicLandingPage />;
}

export default App;
